import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class FloatingTooltipService {
  private tooltipEl?: HTMLDivElement;

  attach(el: HTMLElement, html: string): void {
    el.addEventListener('pointerenter', (e) =>
      this.show(html, e as PointerEvent)
    );
    el.addEventListener('pointermove', (e) =>
      this.move(e as PointerEvent)
    );
    el.addEventListener('pointerleave', () => this.hide());
  }

  private show(html: string, event: PointerEvent): void {
    this.hide();

    const tooltip = document.createElement('div');
    tooltip.className = 'floating-tooltip';

    // 🔥 HTML ENABLED
    tooltip.innerHTML = html;

    document.body.appendChild(tooltip);
    this.tooltipEl = tooltip;

    this.move(event);
  }

  private move(event: PointerEvent): void {
    if (!this.tooltipEl) return;

    const offsetX = 12;
    const offsetY = 10;

    this.tooltipEl.style.left = `${event.clientX + offsetX}px`;
    this.tooltipEl.style.top = `${event.clientY - offsetY}px`;
  }

  private hide(): void {
    this.tooltipEl?.remove();
    this.tooltipEl = undefined;
  }
}
